<template>

    <div class="saque flex flex-col h-full pb-[20px]">
      <div class="flex-1 flex flex-col overflow-y-auto">
        <EnterAmount  :isChannelLoading="isChannelLoading" v-if="sharedData.showAmount !== 2 && sharedData.showAmount !== 3" :channelList="channelList" />
        <EnterMessage  v-if="sharedData.supportTypes &&(sharedData.showAmount !== 2 && sharedData.showAmount !== 3)" @next="sharedData.showAmount = 2" />
        <SaqueSuccess v-if="sharedData.showAmount === 2 || sharedData.showAmount === 3" />
      </div>
    </div>
</template>

<script setup lang="ts">
import { getMoney, getPayChannel } from "@/api/saque";
import EnterAmount from "./compontents/EnterAmount.vue";
import EnterMessage from "./compontents/EnterMessage.vue";
import SaqueSuccess from "./compontents/SaqueSuccess.vue";
const isChannelLoading = ref(false)
const sharedData = ref<any>({
  amount: null, //提现金额
  showAmount: 0, //提现金额页面
  orderNo: "", //订单号
  totalMoney: 0, //钱包余额
  limitAmount: 0, //打码量
  accountName: "", //姓名
  cpf: "", //身份证
  cpfId: "", //身份证id
  accountEmail: "", //邮箱
  accountMobile: "", //手机号
  accountCnpj: "", //公司名称
  username: "", //用户名
  limitMin: 0, //最小提现金额
  limitMax: 0, //最大提现金额
  generalMoneyArr: [], //提现金额列表
  supportTypes: "", //支持的提现方式
});

const channelList = ref<any>([]);
const loadingToast = showLoadingToast({
  message: "loading...",
  forbidClick: true,
  duration: 0,
});
provide("sharedData", sharedData);

const getChannelList = async () => {
  try {
    const { data, code } = await getPayChannel({ type: "Withdrawal" });
    if (code === 1) {
      channelList.value = [data];
      if (channelList.value.length) {
        const channel = channelList.value[0];
        sharedData.value.supportTypes = channel.withdrawMethods;
        sharedData.value.limitMin = Number(channel.minPayAmt);
        sharedData.value.limitMax = Number(channel.maxPayAmt);
        sharedData.value.generalMoneyArr = channel.amounts
          ? channel.amounts.map((item: any) => {
              return {
                amount: item,
              };
            })
          : [];
        isChannelLoading.value = true;
      }
      loadingToast.close();
    }
  } catch (error) {
    loadingToast.close();
    console.log(error);
  }
};
// 查询钱包可用余额 打码量 以及提现详细信息
const queryMoney = async () => {
  const res = await getMoney();
  if (res.code === 1) {
    sharedData.value.totalMoney = res.data?.balance; // 钱包余额
    const fieldsToUpdate = [
      "limitAmount", // 打码量
      "accountName", // 姓名
      "cpf", // 身份证
      "cpfId", // 身份证id
      "accountEmail", // 邮箱
      "accountMobile", // 手机号
      "accountCnpj", // 公司名称
      "accountEvp", // 公司名称
      "username", // 用户名
      "status", // 状态
    ];
    fieldsToUpdate.forEach((field) => {
      sharedData.value[field] = res.data?.[field];
    });
  }
};
getChannelList();
queryMoney();


</script>

<style lang="scss" scoped></style>
